import { OnInit } from "@angular/core";
var FooterComponent = /** @class */ (function () {
    function FooterComponent(settings) {
        this.settings = settings;
    }
    FooterComponent.prototype.ngOnInit = function () {
    };
    return FooterComponent;
}());
export { FooterComponent };
